// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3pR_E","approved":"Status_approved__3HuXg","rejected":"Status_rejected__kpuj8","expired":"Status_expired__24mAS","label":"Status_label__3hJO3"};